import React, { useState } from 'react'
import { EditingItemProps, useClearEditingItem } from 'utils/commonHooks'
import { LogTemplateProps, useInitLog } from 'utils/log'

import FixedArea from './FixedArea'
import InformationArea, {
  InformationAreaProps,
  isInformationAreaProps,
} from './InformationArea'
import RequestArea, { RequestAreaProps } from './RequestArea'
import TrackingArea, {
  isTrackingAreaProps,
  TrackingAreaProps,
} from './TrackingArea'

/**
 * 要請情報送信後の画面用テンプレート
 * 上部に地図または情報を表示し、下部に要請情報・補償情報を表示する。
 */
const RequestedTemplate: React.FC<RequestedTemplateProps> = (props) => {
  useInitLog(props.title)
  const [trackingContent, setTrackingContent] = useState<React.ReactNode>()
  useClearEditingItem(props.notClearEditingItem)

  return (
    <React.Fragment>
      <FixedArea>
        {isTrackingAreaProps(props) && (
          <TrackingArea
            requester={props.requester}
            partner={props.partner}
            partnerStable={props.partnerStable}
            qnStatus={props.qnStatus}
            partnerName={props.partnerName}
            arrivalDuration={props.arrivalDuration}
            siteArrivalScheduleDate={props.siteArrivalScheduleDate}
            timeComingSoon={props.timeComingSoon}
            lastLocationSendDate={props.lastLocationSendDate}
            locationSharingTimeout={props.locationSharingTimeout}
            setTrackingContent={setTrackingContent}
          />
        )}
        {isInformationAreaProps(props) && (
          <InformationArea content={props.content} />
        )}
      </FixedArea>
      <RequestArea state={props.state} trackingContent={trackingContent} />
      {props.modal}
    </React.Fragment>
  )
}

export type RequestedTemplateProps = LogTemplateProps &
  (TrackingAreaProps | InformationAreaProps) &
  RequestAreaProps &
  EditingItemProps & {
    modal?: React.ReactNode
  }

export default RequestedTemplate
